import ProfileCard from '../components/organism/ProfileCard'
import PublicationForm from '../components/organism/PublicationForm'
import Publication from '../components/organism/Publication'
import {publicationData} from '../helpers/data/publication-data'
import uniqid from 'uniqid'
import BirthdaySection from '../components/organism/BirthdaySection'
import AnniversarySection from '../components/organism/AnniversarySection'
import {useMedia} from '../ui-kit/hooks/useMedia'
import {mediaFromLg} from '../ui-kit/helpers/media-queries'
import TabsWrapper from '../ui-kit/components/wrappers/TabsWrapper'
import TabItem from '../ui-kit/components/atoms/items/TabItem'
import PanelTemplate from '../ui-kit/components/templates/PanelTemplate'
import FeedEmptyState from '../components/organism/empty/FeedEmptyState'
import DocumentsSection from '../components/organism/DocumentsSection'

const Home = () => {
  const fromLg = useMedia(mediaFromLg)
  return (
    <div className="home-page wrapper">
      <aside className="aside">
        <ProfileCard />
      </aside>
      <main className="main">
        <TabsWrapper>
          <div className="tabs-container border">
            <TabItem index={0}>Publicaciones</TabItem>
            <TabItem index={1}>Documentos</TabItem>
          </div>
          <PanelTemplate className="feed" index={0}>
            {/* Renderizar este componente si aún no hay publicaciones*/}
            {/*<FeedEmptyState />*/}
            <PublicationForm />
            {publicationData.data.map(publication => (
              <Publication data={publication} key={uniqid()} />
            ))}
          </PanelTemplate>
          <PanelTemplate index={1}>
            <DocumentsSection />
          </PanelTemplate>
        </TabsWrapper>
      </main>
      {fromLg && (
        <aside className="aside">
          <BirthdaySection />
          <AnniversarySection />
        </aside>
      )}
    </div>
  )
}

export default Home
